import React from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Service from "./pages/Service";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Footer from "./pages/Footer";


function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <About />
      <Service />
      <Projects />
      <Footer/>
      
    </div>
  );
}

export default App;
